import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { logout } from '../../../store/actions/AuthActions';
import { isAuthenticated } from '../../../store/selectors/AuthSelectors';
import { FaSignOutAlt } from 'react-icons/fa';

function LogoutPage(props) {
    const dispatch = useDispatch();

    function onLogout() {
        // dispatch(logout(props.history));
        window.dispatchEvent(new Event('userChanged'));
        sessionStorage.removeItem("userDetails");
        props.history.push("/login")
    }
    return (
        <a className="ai-icon" onClick={onLogout} style={{ cursor: 'pointer' }}>
            <FaSignOutAlt />
            <span className="nav-text">Logout</span>
        </a>
    )
}
const mapStateToProps = (state) => {
    return {
        isAuthenticated: isAuthenticated(state),
    };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));